import { media } from '@hg/stylizator/utils'
import * as React from 'react'
import styled from 'styled-components'

const HomepageHeroInnerBlocks: React.FC<React.PropsWithChildren<{}>> = (props) => {
  return <InnerBlocksWrapper>{props.children}</InnerBlocksWrapper>
}

const InnerBlocksWrapper = styled.div`
  margin: 25px;
  margin-top: 0;
  align-self: center;
  min-width: 296px;
  width: 100%;

  @media ${media.mobile}, ${media.tablet} {
    margin-bottom: 0;
  }
`

export default HomepageHeroInnerBlocks
